

import { useState } from "react";
import { Home, Info, Loader, MoreHorizontal, Phone, Plug } from "lucide-react";

import InfoList from "./InfoList";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

class Properties {
  area: any;
}

export default function AreaProperties(properties: Properties) {
  const [tab, setTab] = useState('general');

  return (
    <div className="flex min-w-0 max-w-[1400px] flex-col gap-4">
      {/* Werkzeugleiste wie die frühere CommandBar: Hauptpunkte als
          Schaltflächen, der Überlaufpunkt hinter dem „…“-Menü. */}
      <div role="toolbar" aria-label="" className="flex flex-wrap items-center gap-1 border-b pb-1">
        <Button type="button" variant="ghost" size="sm" className="gap-2" onClick={() => setTab('general')}>
          <Info aria-hidden="true" className="h-4 w-4" />
          <span>Allgemein</span>
        </Button>
        <Button type="button" variant="ghost" size="sm" className="gap-2" onClick={() => setTab('housing')}>
          <Home aria-hidden="true" className="h-4 w-4" />
          <span>Bebauung</span>
        </Button>
        <Button type="button" variant="ghost" size="sm" className="gap-2" onClick={() => setTab('energyManagement')}>
          <Plug aria-hidden="true" className="h-4 w-4" />
          <span>Energiemanagement</span>
        </Button>
        <Button type="button" variant="ghost" size="sm" className="gap-2" onClick={() => setTab('mobileCoverage')}>
          <Phone aria-hidden="true" className="h-4 w-4" />
          <span>Mobilfunk</span>
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button type="button" variant="ghost" size="sm" aria-label="More">
              <MoreHorizontal aria-hidden="true" className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuItem className="gap-2" onSelect={() => setTab('sociodemographics')}>
              <Loader aria-hidden="true" className="h-4 w-4" />
              <span>Soziodemographie</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      {(() => {
        switch (tab) {
          case 'general': return <div className="flex min-w-0 flex-col gap-2">
            <h3 className="text-base font-semibold leading-tight">Bevölkerung</h3>
            <InfoList list={[
              {
                label: 'Bevölkerung',
                value: `${properties.area.population}`,
              },]}></InfoList>
          </div>
          case 'housing': return <div className="flex min-w-0 flex-col gap-2">
            <h3 className="text-base font-semibold leading-tight">Miete</h3>
            <InfoList list={[
              {
                label: 'Miete pro m2',
                value: properties.area.averageRentSqm,
                suffix: '€/m²'
              },]}></InfoList>
          </div>;
          case 'energyManagement': return <div className="grid min-w-0 gap-4 sm:grid-cols-2">
            <div className="flex min-w-0 flex-col gap-2">
              <h3 className="text-base font-semibold leading-tight">Heizquellen</h3>
              <InfoList list={[
                {
                  label: 'Gesamt',
                  value: properties.area.heatingCount,
                },
                {
                  label: 'Fernwärme',
                  value: properties.area.districtHeatingCount,
                },
                {
                  label: 'Etagenheizung',
                  value: properties.area.storeyHeatingCount,
                },
                {
                  label: 'Blockheizkraftwerk',
                  value: properties.area.blockHeatingCount,
                },
                {
                  label: 'Zentralheizung',
                  value: properties.area.centralHeatingCount,
                },
                {
                  label: 'Ofenheizung',
                  value: properties.area.ovenHeatingCount,
                },
                {
                  label: 'Keine Heizung',
                  value: properties.area.noHeatingCount,
                },
              ]}></InfoList>
            </div>
            <div className="flex min-w-0 flex-col gap-2">
              <h3 className="text-base font-semibold leading-tight">Energiequellen</h3>
              <InfoList list={[
                {
                  label: 'Gesamt',
                  value: properties.area.totalEnergySourceCount,
                },
                {
                  label: 'Gas',
                  value: properties.area.gasEnergySourceCount,
                },
                {
                  label: 'Öl',
                  value: properties.area.oilEnergySourceCount,
                },
                {
                  label: 'Holz und Pellets',
                  value: properties.area.woodEnergySourceCount,
                },
                {
                  label: 'Biomasse',
                  value: properties.area.bioMassGasEnergySourceCount,
                },
                {
                  label: 'Solar/Geo/Wärmepumpe',
                  value: properties.area.solarGeoHeatPumpEnergySourceCount,
                },
                {
                  label: 'Eletrizität',
                  value: properties.area.electricalEnergySourceCount,
                },
                {
                  label: 'Kohle',
                  value: properties.area.coalEnergySourceCount,
                },
                {
                  label: 'Keine',
                  value: properties.area.noSourceCount,
                },
              ]}></InfoList>
            </div>
          </div>
        }
      })()}
    </div>
  );
}
